import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin/login");
      return;
    }
    const sessionId = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: data.user } });
      } catch (e) {
        console.error(e);
        navigate("/admin/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F6]">
      <div className="text-center">
        <div className="overline text-[#4A4742] mb-4">Signing you in</div>
        <div className="text-2xl font-serif text-[#1B3B36]">JetsetLess</div>
      </div>
    </div>
  );
}
